import { render, staticRenderFns } from "./InstrumentStatus.vue?vue&type=template&id=3b20fa0c&"
import script from "./InstrumentStatus.vue?vue&type=script&lang=ts&"
export * from "./InstrumentStatus.vue?vue&type=script&lang=ts&"
import style0 from "./InstrumentStatus.vue?vue&type=style&index=0&id=3b20fa0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports